export default __webpack_public_path__ + "static/media/ketoicecream@2x.7e7f85a9.jpg";